import MapControlLayer from "../MapControlLayer";

export default class LabelAnnotationLayer extends MapControlLayer {
    static NORMAL_STYLE_PROPERTIES = {
        label: "label",
        labelColor: "labelColor",
        labelHaloColor: "labelHaloColor"
    }

	static STATUS_VISIBLE_STYLE_PROPERTIES = {
        label: "statusVisibleLabel",
        labelColor: "statusVisibleLabelColor",
        labelHaloColor: "statusVisibleLabelHaloColor"
    }

    constructor(id, dataStream, selectionDataStream, propertiesDictionary, linkedHideable) {
        super(id, dataStream, selectionDataStream, linkedHideable);

        if (propertiesDictionary) {
            this.propertiesDictionary = propertiesDictionary;
        } else {
            this.propertiesDictionary = this.NORMAL_STYLE_PROPERTIES;
        }
    }

    getLabelExpression() {
        return [ "get", this.propertiesDictionary.label ];
    }

    getLabelColorExpression() {
        return [ "get", this.propertiesDictionary.labelColor ];
    }

    getLabelHaloColorExpression() {
        return [ "get", this.propertiesDictionary.labelHaloColor ];
    }
}